import { render, staticRenderFns } from "./radioPartsDialog.vue?vue&type=template&id=c45e1f16&scoped=true"
import script from "./radioPartsDialog.vue?vue&type=script&lang=js"
export * from "./radioPartsDialog.vue?vue&type=script&lang=js"
import style0 from "./radioPartsDialog.vue?vue&type=style&index=0&id=c45e1f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45e1f16",
  null
  
)

export default component.exports